/* iTOVi — scroll-driven scan → pluck.
   As you scroll: a beam sweeps the sea, matched oils' % count up and lock in,
   then the 3 picks pull forward one by one as buyable 3D-look bottle cards. */
(function(){
  const track = document.querySelector('.scan2-track');
  if (!track) return;
  const sea    = track.querySelector('.pluck-sea-wrap');
  const beam   = track.querySelector('.scan2-beam');
  const chips  = [...track.querySelectorAll('.scan2-match')];
  const statusEl = track.querySelector('.scan2-status .s-text');
  const cards  = [...track.querySelectorAll('.pluck-card')];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const targets = chips.map(c => +c.dataset.target || 90);
  const easeOut = t => 1 - Math.pow(1 - t, 3);
  const clamp = v => Math.min(1, Math.max(0, v));

  function endState(){
    chips.forEach((c,i)=>{ const b=c.querySelector('b'); if(b) b.textContent=targets[i]+'%'; c.classList.add('locked'); c.style.opacity='0'; });
    cards.forEach(c=>{ c.style.opacity='1'; c.style.transform='none'; });
    if (beam) beam.style.opacity='0';
    if (statusEl) statusEl.textContent='3 matches found';
  }

  function update(){
    const rect = track.getBoundingClientRect();
    const total = track.offsetHeight - window.innerHeight;
    const p = total>0 ? clamp(-rect.top / total) : 0;
    const scanP  = clamp(p / 0.55);             // scan phase 0..1
    const pluckP = clamp((p - 0.55) / 0.4);     // pluck phase 0..1

    if (beam && sea){
      beam.style.transform = 'translateY(' + (easeOut(scanP) * sea.clientHeight) + 'px)';
      beam.style.opacity = (scanP < 1 && pluckP === 0) ? '0.9' : '0';
    }
    const grow = window.innerWidth < 640 ? 0.45 : 1.15;   // chips grow less on small screens
    chips.forEach((c,i) => {
      const b = c.querySelector('b'); if (b) b.textContent = Math.round(easeOut(scanP) * targets[i]) + '%';
      c.classList.toggle('locked', scanP >= 0.98);
      c.style.opacity = String(clamp(scanP*1.6) * (1 - pluckP));
      c.style.transform = 'translate(-50%,-50%) scale(' + (0.8 + easeOut(scanP) * grow).toFixed(3) + ')';
    });
    if (statusEl) statusEl.textContent = scanP < 0.45 ? 'Reading responses…' : (scanP < 0.98 ? 'Matching the catalog…' : (pluckP < 0.4 ? 'Scan complete' : '3 matches found'));
    cards.forEach((card,i) => {
      const cp = clamp((pluckP - i * 0.22) / 0.5);
      card.style.opacity = String(cp);
      card.style.transform = 'translateY(' + ((1-cp)*60) + 'px) scale(' + (0.78 + cp*0.22) + ')';
    });
  }

  if (reduce){ endState(); return; }
  var _rafT=false;function _updateT(){if(_rafT)return;_rafT=true;requestAnimationFrame(function(){update();_rafT=false;});}window.addEventListener('scroll', _updateT, { passive:true });
  window.addEventListener('resize', update, { passive:true });
  update();
})();
